import { LogglyTracker } from 'loggly-jslogger';

const logglyKey = process.env.REACT_APP_LOGGLY_KEY;


const loggly = new LogglyTracker();
loggly.push({ logglyKey });

export default loggly;
